import { render, staticRenderFns } from "./help04.vue?vue&type=template&id=1410b20a&"
import script from "./help04.vue?vue&type=script&lang=js&"
export * from "./help04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports